import axios from 'axios'
import axiosNoToast from './axiosNoToast'

export interface CompanyPortalChannels {
    hasBroker?: boolean
    hasCor?: boolean
    hasMiniCor?: boolean
}

export interface SyncPortalModeResponse {
    success: boolean
    data: {
        currentSelection: string
        previousSelection: string | null
        updated: boolean
        allowedModes: string[]
    }
    company?: CompanyPortalChannels
}

class PortalModeService {
    async getPortalMode() {
        const response = await axios.get(`/mortdash/pml/portal-mode`)
        return response.data
    }

    async updatePortalMode(data: any) {
        const response = await axios.post(`/mortdash/pml/update-portal-mode`, data)
        return response.data
    }

    async syncPortalModeWithCompany(): Promise<SyncPortalModeResponse> {
        const response = await axiosNoToast.post<SyncPortalModeResponse>(`/mortdash/pml/sync-portal-mode`)
        return response.data
    }
}

export default new PortalModeService() 

